export default __webpack_public_path__ + "img/check-circle.946de943.png";